'use strict';

var app = new Vue({
    el: '#andre-sporsmal-app',
    data: {
        // Member access
        isMember: window.TechnicalFormConfig ? window.TechnicalFormConfig.isMember : false,
        loginUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.loginUrl : '/Account/Login',
        registerUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.registerUrl : '/bli-medlem',

        currentStep: 1,
        loading: false,
        errors: {},

        // Sub-type
        subType: null,

        // Contact info
        memberNumber: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        phone: '',
        email: '',

        // Vehicle info (for member-vehicle)
        vinOrRegNumber: '',
        carMake: '',
        carModel: '',
        constructionYear: '',
        engineVolume: '',
        engineEffect: '',
        selectedTransmission: '',

        // Free text vehicle info (for non-member)
        vehicleInfo: '',

        // Question
        question: '',

        // Other comments
        otherComments: '',

        // File uploads - stored locally until form submission
        localFiles: []
    },
    computed: {
        subTypeTitle: function subTypeTitle() {
            switch (this.subType) {
                case 'member-vehicle':
                    return 'Spørsmål om kjøretøy';
                case 'member':
                    return 'Generelle spørsmål';
                case 'non-member':
                    return 'Generelt spørreskjema';
                default:
                    return 'Andre spørsmål';
            }
        }
    },
    created: function created() {
        // Non-members skip step 1 and go directly to form
        if (!this.isMember) {
            this.subType = 'non-member';
        }
    },
    methods: {
        selectSubType: function selectSubType(type) {
            this.subType = type;
            this.currentStep = 2;
        },
        nextStep: function nextStep() {
            if (this.currentStep === 1 && this.subType) {
                this.currentStep = 2;
            }
        },
        prevStep: function prevStep() {
            if (this.currentStep > 1) {
                this.currentStep = 1;
                this.subType = null;
            }
        },
        validateForm: function validateForm() {
            this.errors = {};

            // Contact info validation
            if (!this.name) this.errors.name = 'Du må fylle ut navn';
            if (!this.address) this.errors.address = 'Du må fylle ut adresse';
            if (!this.zipCode) this.errors.zipCode = 'Du må fylle ut postnummer';
            if (!this.city) this.errors.city = 'Du må fylle ut poststed';
            if (!this.phone) this.errors.phone = 'Du må fylle ut telefonnummer';
            if (!this.email) this.errors.email = 'Du må fylle ut e-postadresse';

            if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.errors.email = 'Ugyldig e-postadresse';
            }

            // Member number required for members
            if (this.isMember && !this.memberNumber) {
                this.errors.memberNumber = 'Du må fylle ut medlemsnummer';
            }

            // Vehicle info required for member-vehicle
            if (this.subType === 'member-vehicle') {
                if (!this.vinOrRegNumber) this.errors.vinOrRegNumber = 'Du må fylle ut VIN eller reg.nr.';
                if (!this.carMake) this.errors.carMake = 'Du må fylle ut bilmerke';
                if (!this.carModel) this.errors.carModel = 'Du må fylle ut modellbetegnelse';
                if (!this.constructionYear) this.errors.constructionYear = 'Du må fylle ut årsmodell';
            }

            // Question always required
            if (!this.question) this.errors.question = 'Du må fylle ut spørsmålet ditt';

            return Object.keys(this.errors).length === 0;
        },
        handleFileUpload: function handleFileUpload(event, fileType) {
            var files = event.target.files;
            if (!files || files.length === 0) return;

            var MAX_TOTAL_SIZE_BYTES = 52428800;
            var currentTotal = this.localFiles.reduce(function (sum, f) {
                return sum + f.file.size;
            }, 0);
            var incoming = 0;
            for (var j = 0; j < files.length; j++) {
                incoming += files[j].size;
            }
            if (currentTotal + incoming > MAX_TOTAL_SIZE_BYTES) {
                alert('Filene er for store. Maks totalstørrelse er 50 MB.');
                event.target.value = '';
                return;
            }

            // Store files locally - will be uploaded on form submission
            for (var i = 0; i < files.length; i++) {
                this.localFiles.push({
                    file: files[i],
                    name: files[i].name,
                    type: fileType
                });
            }

            event.target.value = '';
        },
        removeFile: function removeFile(file) {
            var index = this.localFiles.indexOf(file);
            if (index > -1) {
                this.localFiles.splice(index, 1);
            }
        },
        submitForm: function submitForm() {
            var self = this;
            if (!this.validateForm()) {
                var firstError = document.querySelector('.text-danger');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            this.loading = true;

            // Build FormData for multipart submission
            var formData = new FormData();

            formData.append('subType', this.subType);
            formData.append('memberNumber', this.memberNumber || '');
            formData.append('name', this.name);
            formData.append('address', this.address);
            formData.append('zipCode', this.zipCode);
            formData.append('city', this.city);
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('vinOrRegNumber', this.vinOrRegNumber || '');
            formData.append('carMake', this.carMake || '');
            formData.append('carModel', this.carModel || '');
            formData.append('constructionYear', this.constructionYear || '');
            formData.append('engineVolume', this.engineVolume || '');
            formData.append('engineEffect', this.engineEffect || '');
            formData.append('selectedTransmission', this.selectedTransmission || '');
            formData.append('vehicleInfo', this.vehicleInfo || '');
            formData.append('question', this.question);
            formData.append('otherComments', this.otherComments || '');

            // Add files with type-prefixed names
            this.localFiles.forEach(function (fileObj) {
                formData.append('files-' + fileObj.type, fileObj.file, fileObj.name);
            });

            axios.post('/teknisk/andre-sporsmal', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function () {
                window.location.href = '/teknisk/skjema/takk?skjema=' + encodeURIComponent(window.location.pathname);
            }).catch(function (error) {
                alert('En feil oppstod ved innsending av skjemaet. Vennligst prøv igjen.');
                self.loading = false;
            });
        }
    }
});